import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

const ExpireLink = () => {
  return (
    <div>
      <Modal centered isOpen={true}>
        <ModalBody className='text-center'>Link is expire</ModalBody>
      </Modal>
    </div>
  );
};

export default ExpireLink;
